module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "VirtualConsult",
    class: {
      "is-scrolling": _vm.$store.state.nav || _vm.$route.name != "Home"
    }
  }, [_c('a', {
    attrs: {
      "href": "/virtual-orthodontic-consultation"
    }
  }, [_vm._v("Request A Virtual Orthodontic Consultation")])]), _c('BaseBaseAccess'), _c('Navigation'), _c('router-view'), _c('Footer'), _c('transition', {
    attrs: {
      "name": "fade-in-out"
    }
  }, [_c('Modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.showModal),
      expression: "$store.state.showModal"
    }]
  })], 1), _c('transition', {
    staticClass: "custom-practice-office__transition",
    attrs: {
      "name": "fade-in-out"
    }
  }, [_c('VideoModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.video),
      expression: "$store.state.video"
    }]
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66fb3886","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/base/app.pug
// module id = 701
// module chunks = 1